<template>
    <div style="background: #fff;padding: 10px;"
     v-loading="loading">
        <!-- 顶部材料统计表格 -->
        <div style="margin-bottom: 20px;" v-if="sureestimatelist.length > 0">
            <div style="margin-bottom: 10px; text-align: right;">
                <div>材料单格(KG/元)</div>
                <el-radio-group v-model="tableColumnSpan" size="small">
                    <el-radio-button :label="6">4列</el-radio-button>
                    <el-radio-button :label="4">6列</el-radio-button>
                </el-radio-group>
            </div>
            <div>
                <el-input v-model="searchname" placeholder="输入搜索材料名" clearable style="width: 200px;">
                    <template #prefix>
                        <el-icon>
                            <Search />
                        </el-icon>
                    </template>
                </el-input>

            </div>
            <div style="max-height: 200px; overflow-y: auto; padding-right: 5px;">
                <el-row :gutter="15">
                    <el-col v-for="(item, index) in sureestimatelist" :key="index" :span="tableColumnSpan"
                        style="margin-bottom: 15px;">
                        <div v-if="item.name"
                            style="border: 1px solid #dcdfe6; border-radius: 4px; padding: 15px; background: #fff;">
                            <div style="margin-bottom: 10px; font-weight: 500; color: #606266;font-size: 14px;">
                                {{ item.name }}
                            </div>
                            <el-input v-model="item.price" placeholder="请输入价格" clearable size="small"
                                @blur="handleMaterialChange(item)" />
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 提交按钮 -->
        <div style="margin: 20px; text-align: right;" v-if="sureestimatelist.length > 0">
            <el-button type="primary" @click="suretosetimste(currentNode)">确定估算</el-button>
        </div>
    </div>

    <!-- <el-button type="primary">添加</el-button> -->
    <el-tree ref="elTreeRef" :data="data" :props="defaultProps" node-key="id" @node-click="handleNodeClick" lazy
        :load="loadNode" @check="handleCheck" v-loading="treeLoading">
        <template #default="{ node, data }">
            <div class="custom-tree-node">
                <div class="node-label-wrapper">
                    <template v-if="node.level === 5">
                        <div v-if="inlineEditNodeId === data.id" class="inline-edit-container">
                            <el-input v-model="inlineEditValue" size="small" autofocus
                                @blur="confirmInlineEdit(node, data)"
                                @keyup.enter="confirmInlineEdit(node, data)"
                                @keyup.esc.stop.prevent="cancelInlineEdit" />
                        </div>
                        <span v-else class="editable-label" @click.stop="startInlineEdit(node, data)">
                            {{ node.label }}
                        </span>
                    </template>
                    <span v-else>{{ node.label }}</span>
                </div>
                <div>
                    <el-button v-if="node.level === 2" type="primary" link
                        @click.stop="estimatedtransactionpricefun(node, data)">
                        显示材料列表
                    </el-button>
                    <el-button v-if="node.level === 4" type="primary" link @click.stop="addpendopen(node, data)">
                        添加明细
                    </el-button>

                    <!-- <el-button style="margin-left: 4px" type="info" link @click.stop="perview(node, data)"
                        v-if="data.imglist || data.imglist2">
                        查看图片
                    </el-button> -->
                    <el-button v-if="node.level === 5" style="margin-left: 4px" type="info" link
                        @click.stop="update(node, data)">
                        修改
                    </el-button>
                    <el-button v-if="node.level === 5" style="margin-left: 4px" type="danger" link
                        @click.stop="remove(node, data)">
                        删除
                    </el-button>
                </div>
            </div>
        </template>

    </el-tree>

    <!-- 修改材料弹出框 -->
    <el-dialog v-model="dialogVisible" :title="isEdit ? '修改材料' : '添加材料'" width="500px" :before-close="handleClose">
        <el-input v-model="formData.name" placeholder="输入搜索材料名" clearable>
            <template #prefix>
                <el-icon>
                    <Search />
                </el-icon>
            </template>

        </el-input>
        <div class="material-chip-container">
            <div class="material-chip" :class="{ disabled: item.disabled }" 
            v-for="(item,index) in materialNamelist"
                :key="index" @click="selectMaterial(item)">
                {{ item.name }}
            </div>
        </div>
        <el-form :model="formData" ref="formRef" label-width="100px">


            <el-form-item label="材料名" prop="name" required>
                <el-input v-model="formData.name" placeholder="请输入名称" clearable />
            </el-form-item>



            <!-- <el-form-item label="数量" prop="number">
                <el-input v-model="formData.number" placeholder="请输入数量" clearable type="number" />
            </el-form-item> -->

            <el-form-item label="重量(KG)" prop="heavey">
                <el-input v-model="formData.heavey" placeholder="请输入重量" clearable type="number" />
            </el-form-item>

            <!-- <el-form-item label="单价" prop="currentprice">
                <el-input v-model="formData.currentprice" placeholder="请输入单价" clearable type="number" />
            </el-form-item> -->

            <!-- <el-form-item label="材料图" prop="image">
                <el-upload class="image-uploader" :action="uploadAction" :show-file-list="false"
                    :on-success="handleImageSuccess" :before-upload="beforeImageUpload">
                    <div v-if="formData.imglist" class="image-preview">
                        <img :src="formData.image" class="uploaded-image" />
                        <div class="image-overlay">
                            <el-icon class="delete-icon" @click.stop="removeImage">
                                <Delete />
                            </el-icon>
                        </div>
                    </div>
                    <el-icon v-else class="image-uploader-icon">
                        <Plus />
                    </el-icon>
                </el-upload>
            </el-form-item> -->
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" @click="handleSubmit">确定</el-button>
            </span>
        </template>
    </el-dialog>

    <!-- 图片预览对话框 -->
    <!-- <el-dialog v-model="imagePreviewVisible" title="图片预览" width="80%" :before-close="handleImagePreviewClose">
        <div style="display: flex; flex-wrap: wrap; gap: 20px; justify-content: center;">
            <div v-for="(imageUrl, index) in previewImageList" :key="index" style="margin-bottom: 20px;">
                <el-image :src="imageUrl" :preview-src-list="previewImageList" :initial-index="index" fit="contain"
                    style="width: 300px; height: 300px; cursor: pointer;" :preview-teleported="true" />
            </div>
        </div>
    </el-dialog> -->

</template>

<script>
import {
  ElLoading,
  ElMessage,
  ElMessageBox,
} from 'element-plus';

import request from '@/api/api';
import {
  Delete,
  Plus,
  Search,
} from '@element-plus/icons-vue';

export default {
    components: {
        Search,
        Plus,
        Delete
    },
    data() {
        return {
            page: 1,
            searchname:'',
            pageSize: 100,
            tenderbatch: '第6批',
            datalistSoucemap: [],
            datalist: [],
            data: [],
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            datalistdt: [],
            datalistdt2: [],
            tenderid: null,
            findtage05: [],
            findtage055: [],
            lists: [],
            totype: 0,
            statusprodect: {
                '未拆解': 'warning',
                '拆解中': 'info',
                '拆解完': 'success'
            },
            statusprodectcolor: {
                '未拆解': '#f56c6c',
                '拆解中': '#409EFF',
                '拆解完': '#67C23A',
            },

            productname: '',
            tendername: '',
            nodeid: '',
            nodeActive: '',
            // 弹出框相关
            dialogVisible: false,
            formRef: null,
            isEdit: false, // 是否为编辑模式
            editId: null, // 编辑的记录ID
            formData: {
                addname: "",
                currentprice: "",
                heavey: "",
                imglist: "",
                imglist2: "",
                materialid: '',
                moneys: '',
                name: "",
                number: "1",
                productid: "",
                tenderdetailid: '',
                unit: "",
            },

            uploadAction: '/api/upload', // 根据实际接口修改
            currentNode: null,
            currentData: null,
            materialNamelist: [],
            // 顶部材料统计表格数据
            materialTableData: [
                {
                    name: '材料统计',
                    copper: '',
                    aluminum: '',
                    iron: ''
                }
            ],
            // 图片预览相关
            imagePreviewVisible: false,
            previewImageList: [],
            imageBaseUrl: 'https://abc.smbmhs.cn/',
            nameSkuList: [],
            // 表格列数配置: 4列(span=6) 或 6列(span=4)
            tableColumnSpan: 6, // 6表示4列, 4表示6列
            estimate: 1,
            sureestimatelist:[],
            inlineEditNodeId: null,
            inlineEditValue: '',
            inlineEditSubmitting: false,
            loading: false,
            treeLoading: false,
        }
    },
    mounted() {
        // this.getbtch()
        // this.getnameSku();
    },
    watch: {
        'formData.name'(newVal) {
            this.findmater()
        },
        "searchname"(newVal){
            this.searchnamefun()
        }
    },
    methods: {
        getnameSku() {
            request('/productElement/getlistbyname', "post", { nameSku: "" }).then(res => {
                this.nameSkuList = res.data.data
                console.log(res, 'res');
            })
        },
        perview(node, data) {
            // 解析图片列表并拼接完整URL
            this.previewImageList = [];

            // 处理 imglist
            if (data.imglist) {
                const imglistArray = data.imglist.split(',').map(img => img.trim()).filter(img => img);
                imglistArray.forEach(imgName => {
                    if (imgName) {
                        this.previewImageList.push(`${this.imageBaseUrl}${imgName}`);
                    }
                });
            }

            // 处理 imglist2
            if (data.imglist2) {
                const imglist2Array = data.imglist2.split(',').map(img => img.trim()).filter(img => img);
                imglist2Array.forEach(imgName => {
                    if (imgName) {
                        this.previewImageList.push(`${this.imageBaseUrl}${imgName}`);
                    }
                });
            }

            // 如果有图片,显示预览对话框
            if (this.previewImageList.length > 0) {
                this.imagePreviewVisible = true;
            } else {
                ElMessage.warning('暂无图片可预览');
            }
        },
        handleImagePreviewClose() {
            this.imagePreviewVisible = false;
            this.previewImageList = [];
        },
        handleSubmit1() {
            // 提交材料价格数据
            console.log('提交材料价格数据:', this.nameSkuList);

            // 这里可以添加提交逻辑,比如调用API保存数据
            // request('/api/saveMaterialPrice', 'post', {
            //     data: this.nameSkuList
            // }).then(res => {
            //     ElMessage.success('提交成功');
            // }).catch(err => {
            //     ElMessage.error('提交失败');
            // });

            ElMessage.info('提交功能待实现');
        },
        handleMaterialChange(row) {
            // 处理材料数据变化
            console.log('材料价格变更:', row);
            // 这里可以添加保存逻辑,比如调用API保存数据
            // request('/api/saveMaterialPrice', 'post', {
            //     id: row.id,
            //     nameSku: row.nameSku,
            //     commodityprice: row.commodityprice
            // }).then(res => {
            //     ElMessage.success('保存成功');
            // }).catch(err => {
            //     ElMessage.error('保存失败');
            // });
        },
        searchnamefun(){
            const filteredList = this.nameSkuList.filter(item =>
                item.name.includes(this.searchname)
            );
            this.sureestimatelist = filteredList;
        },
        findmater() {
            request('/productElement/getlistbyname', "post", { name: this.formData.name,virtual:0 }).then(res => {
                console.log(res, 'res');
                const list = res?.data?.data || [];
                const usedNameSet = new Set();
                if (this.currentNode && this.currentNode.childNodes) {
                    this.currentNode.childNodes.forEach(child => {
                        const childName = child.data?.name || '';
                        if (childName) {
                            usedNameSet.add(childName);
                        }
                    });
                }

                this.materialNamelist = list.map(item => ({
                    ...item,
                    disabled: usedNameSet.has(item.name)
                }));
            })
        },
        selectMaterial(item) {
            if (item.disabled) {
                return;
            }
            this.formData.name = item.name;
            this.formData.currentprice = item.priceNow;
            this.formData.materialid = item.productElementId;
            this.materialNamelist = [];
        },
        addpendopen(node, data) {
            console.log('node,data', node, data,node.data.bidDetailsId);
            this.currentNode = node;
            this.currentData = data;
            this.isEdit = false;
            this.editId = null;
            // 重置表单数据
            this.formData = {
                addname: "",
                currentprice: "",
                heavey: "",
                imglist: "",
                imglist2: "",
                materialid: '',
                moneys: '',
                name: "",
                number: "1",
                productid: "",
                tenderdetailid: node.data.bidDetailsId,
                unit: "",
            };
            this.formData.tenderdetailid= node.data.bidDetailsId;
            
            // 打开对话框
            this.dialogVisible = true;
        },
        update(node, data) {
            console.log('update node,data', node, data);
            this.currentNode = node;
            this.currentData = data;
            this.isEdit = true;
            this.editId = data.id;
            // 填充表单数据(从当前节点数据中获取)
            this.formData = {
           

                heavey: data.quantity || "",
                materialid: data.productElementId || '',
                moneys: data.price || '',
                name: data.nameElement || "",
                number: data.number || "1",
                tenderdetailid: data.productStoreId ,
                unit: data.unit || "",
            };
            // 打开对话框
            this.dialogVisible = true;
        },
        handleClose() {
            this.dialogVisible = false;
            this.isEdit = false;
            this.editId = null;
            // 重置表单
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
            this.formData = {
                addname: "",
                currentprice: "",
                heavey: "",
                imglist: "",
                imglist2: "",
                materialid: '',
                moneys: '',
                name: "",
                number: "1",
                productid: "",
                tenderdetailid: '',
                unit: "",
            };
        },
        handleSubmit() {
            // 提交表单逻辑
            console.log('Submitted data:', this.formData);

            // 验证和格式化 currentprice
            let formattedPrice = null;
            if (this.formData.currentprice !== '' && this.formData.currentprice !== null && this.formData.currentprice !== undefined) {
                const priceStr = String(this.formData.currentprice).trim();
                const numPrice = parseFloat(priceStr);

                if (!isNaN(numPrice) && numPrice >= 0) {
                    // 保留2位小数(根据数据库字段精度调整)
                    formattedPrice = parseFloat(numPrice.toFixed(4));
                }
            } else {
                // 如果为空,设置为0或null(根据数据库要求)
                formattedPrice = 0;
            }

            // 获取当前节点的前两级节点(level 2)的 id 作为 bidId
            let bidId = 1; // 默认值
            if (this.currentNode && this.currentNode.parent && this.currentNode.parent.parent) {
                const level2Node = this.currentNode.parent.parent;
                if (level2Node && level2Node.data && level2Node.data.id) {
                    bidId = level2Node.data.id;
                    console.log('获取前两级节点 bidId:', bidId, 'level2Node:', level2Node.data);
                }
            }

            const submitData = {
                bidId: bidId,
                sourceId: this.formData.tenderdetailid,
                source:3,
                name: this.formData.name,
                remark:'product_bidDetailPacking',
                number: this.formData.number,
                quantity: this.formData.heavey,
                price: formattedPrice,
                createBy:'tree',
                productElementId: this.formData.materialid,
                unit: this.formData.unit,
         
            };

            // 如果是编辑模式,添加id并调用update接口
            if (this.isEdit && this.editId) {
                submitData.id = this.editId;
                request('/productStore/updatebyid', "post", {
                     productStoreId: this.formData.tenderdetailid ,
                     unit: this.formData.unit,
                     productElementId: this.formData.materialid,
                     quantity: this.formData.heavey,
                    
                    })
                    .then(res => {
                        console.log(res, '更新');
                        ElMessage.success('更新成功');
                        this.updateBuilding();
                        // 关闭对话框
                        this.handleClose();
                    })
                    .catch(err => {
                        console.error(err);
                        ElMessage.error('更新失败');
                    });
            } else {
                let isExist = false;
                this.currentNode.childNodes.find(item => {
                    if (item.data.name == this.formData.name) {
                        isExist = true;
                        ElMessage.error('该材料已存在');
                    }
                });
                if (isExist) {
                    return;
                } else {
                    // 添加模式,调用save接口
                    request('/productStore/save', "post", submitData)
                        .then(res => {
                            console.log(res, '添加');
                            ElMessage.success('添加成功');
                            this.updateBuilding();
                            // 关闭对话框
                            this.handleClose();
                            this.sureestimatelist.push(submitData);
                        })
                        .catch(err => {
                            console.error(err);
                            ElMessage.error('添加失败');
                        });
                }
            }
        },
        handleImageSuccess(response, file) {
            // 根据实际API返回格式调整
            this.formData.image = response.url || URL.createObjectURL(file.raw);
            this.$refs.formRef.validateField('image');
        },
        beforeImageUpload(file) {
            const isImage = file.type.startsWith('image/');
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isImage) {
                ElMessage.error('只能上传图片文件!');
                return false;
            }
            if (!isLt2M) {
                ElMessage.error('图片大小不能超过 2MB!');
                return false;
            }
            return true;
        },
        removeImage() {
            this.formData.image = '';
            this.$refs.formRef.validateField('image');
        },
        async loadNode(node, resolve) {
            console.log(node, 'ndoe');
            this.treeLoading = true;
            try {
                this.nodeActive = node;
            if (node.level === 0) {
                const data = await this.getbtch();
                console.log(data, 'data');

                 resolve(data.map(item => ({ ...item, hasChildren: !item.hasChildren })));
            } else if (node.level === 1) {
                const data = await this.getlistall(node.data.label);
                console.log(node.data.label, 'node.data.label', data);

                resolve(data.map(item => ({ ...item, hasChildren: !item.hasChildren, label: item.name, lazy: true })));
            } else if (node.level === 2) {
                const data = await  this.getindexdetail(node.data.id)
        
                console.log(data, 'data三级');
                resolve(data.map(item => ({ label: item.text, name: item.value, children: [] })));
            } else if (node.level === 3) {
                const data = await this.changetype22(node.data.name)

                console.log(data, 'data四级');
                // 确保每个 level 4 节点都有 id 字段(el-tree 的 node-key 是 "id")
                // 使用 bidDetailsId 作为 id,如果没有 bidDetailsId 则使用其他唯一标识
                resolve(data.map(item => ({ 
                    ...item, 
                    id: item.bidDetailsId || item.id || item.bidDetailId, // 确保有 id 字段
                    label: `${item.name}(${item.quantity}${item.unit})${item.model? `_型号:${item.model}` : ''}${item.brand? `_描述:${item.brand}` : ''}_批次号:${item.materialNumber? item.materialNumber : ''}` 
                })));

            } else if (node.level === 4) {
                //拆解详情
                const data = await request('/productStore/findlistbysouceid', "post",
                 { sourceId: node.data.bidDetailsId })
                  console.log(data, 'data五级');
                
                // 确保每个 level 5 节点都有唯一的 id 字段(el-tree 的 node-key 是 "id")
                resolve(data.data.data.map(item => ({ 
                    ...item, 
                    id: item.id || item.productStoreId || item.productstoreId, // 确保有 id 字段
                    label: this.formatLevel5Label(item),
                    hasChildren: false
                })));





            } else {
                resolve([]);
            }
            } catch (error) {
                console.error('加载节点失败:', error);
                ElMessage.error('加载数据失败');
                resolve([]);
            } finally {
                this.treeLoading = false;
            }
        },
        //确定估算总价
        async suretosetimste(node) {

            console.log(node, 'node');
            let currentprice = 0
            let estimate = 0
            if (!node || node.level !== 2) return;
       
            this.sureestimatelist.map(item => {
                currentprice = 0; // 重置价格
                this.nameSkuList.map(m => {
                    if (m.name == item.name) {
                        // 验证和格式化价格
                        const price = m.price;
                        if (price !== '' && price !== null && price !== undefined) {
                            const numPrice = parseFloat(String(price).trim());
                            if (!isNaN(numPrice) && numPrice >= 0) {
                                currentprice = numPrice;
                            }
                        }
                    }
                })

                const heavey = parseFloat(item.heavey) || 0;
                const number =  1;
                const price = parseFloat(currentprice) || 0;

                estimate += heavey * number * price;
                console.log(heavey, number, price, 'item.heavey*item.number*currentprice');
            })
            const target = node.data;                    // el-tree 当前节点的数据
            const baseLabel = target.label.split('_估算总价')[0];   // 去掉旧的估算串
            target.estimatedtransprice = estimate.toFixed(4);  // 保存估算值
            console.log(target.estimatedtransprice, 'target.estimatedtransprice');

            target.label = `${baseLabel}_估算总价:${estimate}元`;

        },
        async estimatedtransactionpricefun(node) {
            // 保存 currentNode 用于后续操作(确定估算按钮等),但不更新树节点显示
            this.currentNode = node;
            this.loading = true;
            try {
                const res = await request('/bid/getsummery', "post", { bidId: node.data.id });
                console.log(res, 'res');
                // 获取新的数据
                const newData = [...new Set(res.data.data)] || [];
                this.nameSkuList = newData;
                
                // 如果 sureestimatelist 为空,直接赋值
                if(this.sureestimatelist.length == 0){
                    this.sureestimatelist = newData;
                } else {
                    // 保留原来的 sureestimatelist,增加 nameSkuList 中没有的数据
                    // 创建一个以 name 为 key 的 Set,用于快速查找 sureestimatelist 中已有的项
                    const sureestimatelistNametdSet = new Set();
                    this.sureestimatelist.forEach(item => {
                        if (item.name) {
                            sureestimatelistNametdSet.add(item.name);
                        }
                    });
                    
                    // 找出 nameSkuList 中不在 sureestimatelist 中的项
                    const newItems = this.nameSkuList.filter(item => 
                        item.name && !sureestimatelistNametdSet.has(item.name)
                    );
                    
                    // 将新项添加到 sureestimatelist
                    if (newItems.length > 0) {
                        this.sureestimatelist = [...this.sureestimatelist, ...newItems];
                    }
                }
            } catch (error) {
                console.error('获取材料列表失败:', error);
                ElMessage.error('获取材料列表失败');
            } finally {
                this.loading = false;
            }
            // 根据 level4 子节点的情况自动展开/收起 level3
            this.$nextTick(() => {
                this.adjustLevel3Nodes(node);
            });
            // 注意: 此方法不调用 updateKeyChildren,不会更新树节点显示
        },
        async adjustLevel3Nodes(level2Node) {
            if (!level2Node) return;
            await this.ensureTreeNodeLoaded(level2Node);
            const level3Nodes = level2Node.childNodes || [];
            for (const level3Node of level3Nodes) {
                await this.ensureTreeNodeLoaded(level3Node);
                const level4Nodes = level3Node.childNodes || [];
                if (level4Nodes.length === 0) continue;

                let shouldExpand = false;
                let shouldCollapse = true;

                for (const level4Node of level4Nodes) {
                    const hasChildren = await this.hasLevel5Children(level4Node);
                    if (!hasChildren) {
                        shouldExpand = true;
                        shouldCollapse = false;
                        break;
                    }
                }

                if (shouldExpand) {
                    if (!level3Node.expanded && typeof level3Node.expand === 'function') {
                        level3Node.expand();
                    }
                } else if (shouldCollapse && typeof level3Node.collapse === 'function') {
                    level3Node.collapse();
                }
            }
        },
        ensureTreeNodeLoaded(node) {
            return new Promise(resolve => {
                if (!node) return resolve();
                if ((node.childNodes && node.childNodes.length > 0) || node.loaded || node.isLeaf) {
                    return resolve();
                }

                if (!node.expanded && typeof node.expand === 'function') {
                    node.expand();
                }

                const start = Date.now();
                const check = () => {
                    if ((node.childNodes && node.childNodes.length > 0) || node.loaded || node.isLeaf) {
                        resolve();
                    } else if (Date.now() - start > 3000) {
                        resolve();
                    } else {
                        setTimeout(check, 80);
                    }
                };

                check();
            });
        },
        async hasLevel5Children(level4Node) {
            if (!level4Node || !level4Node.data || !level4Node.data.id) return false;
            if (level4Node.childNodes && level4Node.childNodes.length > 0) {
                return true;
            }
            if (level4Node.loaded && (!level4Node.childNodes || level4Node.childNodes.length === 0)) {
                return false;
            }
            try {
                const res = await request('/productStore/findlistbysouceid', "post", { sourceId: level4Node.data.bidDetailsId });
                const list = res?.data?.data || [];
                return Array.isArray(list) && list.length > 0;
            } catch (error) {
                console.error('检查 level4 子节点失败', error);
                return false;
            }
        },
        async updateBuilding() {

            // 确定要刷新的目标节点
            // 添加模式:currentNode 是 level 4,直接使用
            // 编辑模式:currentNode 是 level 5,需要使用其父节点(level 4)
            let targetNode = this.currentNode;
            // 如果是 level 5 的节点,使用其父节点(level 4)
            if (targetNode && targetNode.level === 5) {
                targetNode = targetNode.parent;
            }

            // 如果 targetNode 不存在,尝试使用 nodeActive
            if (!targetNode && this.nodeActive) {
                targetNode = this.nodeActive;
                // 如果 nodeActive 也是 level 5,使用其父节点
                if (targetNode && targetNode.level === 5) {
                    targetNode = targetNode.parent;
                }
            }

            if (targetNode && targetNode.data) {
                const data = await request('/productStore/findlistbysouceid', "post", { sourceId: targetNode.data.bidDetailsId })

                // el-tree 的 node-key 是 "id",所以必须使用 id 字段作为 key
                const nodeKey = targetNode.data.id || targetNode.data.bidDetailsId;
                
                // 确保每个 level 5 节点都有唯一的 id 字段,并去重
                const childrenMap = new Map();
                data.data.data.forEach(item => {
                    const id = item.id || item.productStoreId || item.productstoreId;
                    if (id && !childrenMap.has(id)) {
                        childrenMap.set(id, {
                            ...item, 
                            id: id, // 确保有 id 字段
                            label: this.formatLevel5Label(item), 
                            hasChildren: false 
                        });
                    }
                });
                const childrenData = Array.from(childrenMap.values());
                
                console.log('更新 level 4 节点, nodeKey:', nodeKey, '原始数据数量:', data.data.data.length, '去重后数量:', childrenData.length);
                this.$refs.elTreeRef.updateKeyChildren(nodeKey, childrenData);
                
                // 注意:不再更新 level 3 节点,避免数据重复
                // 添加/删除 level 5 节点时,只需要更新 level 4 节点即可
            }
        },

        handleCheck(checkedNodes, checkedNode, node) {
            console.log('Checked nodes:', checkedNodes);
        },
        async getlistall(item) {
            this.tenderbatch = item
            this.datalist = []
            let result = []
            await request("/bid/findAll", "post",
             { type: '全部', page: this.page, pageSize: this.pageSize, tenderbatch: this.tenderbatch }).then(res => {
                result = res.data.data.tenderEntityPageVoList
                console.log('tenderEntityPageVoList', res)
            })
            return result

        },
     async   getindexdetail(id) {
            console.log('this.tenderid', this.tenderid);
        await    request('/bid/finddetialbyid', "post", {
                bidId: id
            }).then(res => {
                console.log(res, 'tenderid');
                this.datalistdt = res.data.data
                this.datalistdt2 = res.data.data
                this.findtage05 = [
                    // 	{
                    // 	value: '0',
                    // 	text: `全部(${this.datalistdt.length})`
                    // },
                ]
                let setlist = new Set()
                this.datalistdt.map(v => {
                    setlist.add(v.name)
                })
                let lists = [...setlist.values()]
                lists.map(v => {
                    let number = 0
                    this.datalistdt.map(m => {
                        if (m.name == v) {
                            number += 1
                        }
                    })
                    this.findtage05.push({
                        text: `${v}(${number})`,
                        value: v
                    })

                })
                // this.data.find(v => v.label === this.productname).children.find(m => m.label === this.tendername).children
                this.findtage055 = this.findtage05
                // this.fuzzySearchall()
    

            })
                 return   this.findtage055

        },
        addpend(data, node) {
            // let newChild = {}
            // this.findtage055.map(m => {
            //     // let children2=[]
            //     // m.list.map(v=>{
            //     //        let newChild2 = { label: v.name, id:v.id,children: [],typenumber:v.typenumber }
            //     //        children2.push(newChild2)
            //     // })
            //     newChild = { label: m.text }
            // })
            // data.children.push(newChild)

        },
        remove(node, data) {
            // 显示确认删除弹框
            ElMessageBox.confirm(
                `确定要删除 "${data.name || data.label}" 吗?`,
                '删除确认',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            ).then(() => {
                // 用户确认删除,调用删除接口
                request('/productStore/detete', "post", { productStoreId: data.productStoreId ,remark:'product_bidDetailPacking'    })
                    .then(res => {
                        console.log(res, '删除');
                        ElMessage.success('删除成功');
                        // 刷新父节点数据
                        this.refreshParentNode(node);
                    })
                    .catch(err => {
                        console.error(err);
                        ElMessage.error('删除失败');
                    });
            }).catch(() => {
                // 用户取消删除
                ElMessage.info('已取消删除');
            });
        },
        formatLevel5Label(item = {}) {
            const name = item.name || item.label || item.nameElement||'';
            const heaveyText = item.quantity ? `${item.quantity}kg` : '';
            // const suffix = numberText || heaveyText ? `(${numberText}${heaveyText})` : '';
            // const priceText = item.currentprice ? `_单价:${item.currentprice}` : '';
            return `${name}  ${heaveyText?'|'+heaveyText:''}`;
        },
        startInlineEdit(node, data) {
            if (node.level !== 5 || this.inlineEditSubmitting) return;
            this.inlineEditNodeId = data.id;
            this.inlineEditValue = data.heavey !== undefined && data.heavey !== null ? String(data.heavey) : '';
        },
        cancelInlineEdit() {
            this.inlineEditNodeId = null;
            this.inlineEditValue = '';
        },
        async confirmInlineEdit(node, data) {
            if (node.level !== 5 || this.inlineEditNodeId !== data.id || this.inlineEditSubmitting) {
                return;
            }

            const value = (this.inlineEditValue ?? '').toString().trim();
            if (!value) {
                ElMessage.warning('请输入重量');
                return;
            }

            const heaveyNumber = parseFloat(value);
            if (isNaN(heaveyNumber) || heaveyNumber < 0) {
                ElMessage.error('重量必须为非负数字');
                return;
            }

            const formattedHeavey = parseFloat(heaveyNumber.toFixed(4));
            const originalHeavey = parseFloat(data.heavey);
            if (!isNaN(originalHeavey) && originalHeavey === formattedHeavey) {
                this.cancelInlineEdit();
                return;
            }

            const submitData = {
                id: data.id,
                tenderdetailid: data.tenderdetailid,
                name: data.name,
                number: data.number,
                heavey: formattedHeavey,
                currentprice: data.currentprice,
                addname: data.addname,
                materialid: data.materialid,
                moneys: data.moneys,
                productid: data.productid,
                unit: data.unit,
                imglist: data.imglist,
                imglist2: data.imglist2,
            };

            this.inlineEditSubmitting = true;
            request('/Productunpacking/update', "post", submitData)
                .then(() => {
                    ElMessage.success('重量已更新');
                    data.heavey = formattedHeavey;
                    const formattedLabel = this.formatLevel5Label(data);
                    data.label = formattedLabel;
                    node.data.label = formattedLabel;
                    this.cancelInlineEdit();
                })
                .catch(err => {
                    console.error(err);
                    ElMessage.error('更新失败');
                })
                .finally(() => {
                    this.inlineEditSubmitting = false;
                });
        },
        async refreshParentNode(node) {
            console.log(node, "refreshParentNode");
            // 刷新父节点(level 4)的数据
            if (node && node.parent && node.parent.data) {
                const parentNode = node.parent;
                console.log('parentNode.data:', parentNode.data);
                console.log('parentNode.data.id:', parentNode.data.id);
                console.log('parentNode.data.bidDetailsId:', parentNode.data.bidDetailsId);
                
                // 确保有 bidDetailsId
                if (!parentNode.data.bidDetailsId) {
                    console.error('parentNode.data.bidDetailsId 不存在');
                    return;
                }
                
                const data = await request('/productStore/findlistbysouceid', "post", { sourceId: parentNode.data.bidDetailsId })
                console.log(data, 'databidDetailsId');
                
                // el-tree 的 node-key 是 "id",所以必须使用 id 字段作为 key
                // 如果 level 4 节点没有 id,使用 bidDetailsId 作为 id
                const nodeKey = parentNode.data.id || parentNode.data.bidDetailsId;
                console.log('使用 nodeKey:', nodeKey, 'parentNode.data:', parentNode.data);
                
                if (!nodeKey) {
                    console.error('无法找到有效的 nodeKey,parentNode.data:', parentNode.data);
                    return;
                }
                
                // 确保每个 level 5 节点都有唯一的 id 字段,并去重
                const childrenMap = new Map();
                data.data.data.forEach(item => {
                    const id = item.id || item.productStoreId || item.productstoreId;
                    if (id && !childrenMap.has(id)) {
                        childrenMap.set(id, {
                            ...item, 
                            id: id, // 确保有 id 字段
                            label: this.formatLevel5Label(item), 
                            hasChildren: false 
                        });
                    }
                });
                const childrenData = Array.from(childrenMap.values());
                
                console.log('更新 level 4 节点(删除后), nodeKey:', nodeKey, '原始数据数量:', data.data.data.length, '去重后数量:', childrenData.length);
                
                // 使用 $nextTick 确保 DOM 更新完成后再更新子节点
                this.$nextTick(() => {
                    try {
                        this.$refs.elTreeRef.updateKeyChildren(nodeKey, childrenData);
                        console.log('更新成功,子节点数量:', childrenData.length);
                    } catch (error) {
                        console.error('updateKeyChildren 失败:', error);
                        // 如果 updateKeyChildren 失败,尝试重新加载节点
                        if (parentNode.expand) {
                            parentNode.expand();
                        }
                    }
                });
            } else {
                console.error('无法找到父节点:', node);
            }
        },

        changetype22(name) {

            let list = [...this.datalistdt2]

            if (name != '0') {
                this.datalistdt = list.filter(v => {
                    if (v.name == name) {
                        return v
                    }
                })

            } else {
                this.datalistdt = list

            }
            console.log(name, this.datalistdt);
            return this.datalistdt
        },
        fuzzySearchall() {
            this.findtage05 = this.findtage055.map(v => {
                // 使用map而不是forEach,因为forEach不返回值
                const newV = { ...v }; // 创建新对象避免修改原数据

                // 获取过滤后的list
                newV.list = this.changetype22(v.value);
                console.log(newV.list, ' newV.list');
                // 检查状态
                if (newV.list && newV.list.length > 0) {
                    const allCompleted = newV.list.every(item => item.statusprodect == '拆解完');
                    newV.tag = allCompleted ? true : false;
                    console.log(allCompleted, 'allCompleted');
                } else {
                    newV.tag = false; // 使用布尔值而不是字符串
                }

                return newV;
            });
            this.findtage055 = this.findtage05

            console.log(this.findtage05, 'this.findtage055拆解');

        },


        getbtch() {
            // /bid/getbatch
            request('/bid/getbatch', "post").then(res => {
                this.datalistSoucemap = res.data.data
                this.datalistSoucemap.map(async item => {
                    let listdata = await this.getlistall(item)
                    console.log(listdata, 'listdata');

                    let children1 = []
                    listdata.map(m => {


                        children1.push({ label: `${m.name}`, id: m.id, estimatedtransprice: 0, children: [], lazy: true, typenumber: m.typenumber })

                    })
                    let obj = { label: item, children: children1 }
                    console.log(obj, 'obj');

                    this.data.push(obj)
                })


                //     console.log(res, 'batch');
            })
            return this.datalistSoucemap
        },
     async   handleNodeClick(data) {
            console.log(data, 'data node click');
       
            // this.refreshParentNode(data)

        }
    },

}
</script>

<style lang="less" scoped>
.image-uploader {
    :deep(.el-upload) {
        border: 1px dashed var(--el-border-color);
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        transition: var(--el-transition-duration-fast);
        width: 178px;
        height: 178px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
            border-color: var(--el-color-primary);
        }
    }
}

.image-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
    line-height: 178px;
}

.image-preview {
    width: 178px;
    height: 178px;
    position: relative;
    border-radius: 6px;
    overflow: hidden;

    .uploaded-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .image-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.3s;

        &:hover {
            opacity: 1;
        }

        .delete-icon {
            color: #fff;
            font-size: 24px;
            cursor: pointer;
        }
    }
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}
</style>
<style>
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
.node-label-wrapper {
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
    margin-right: 12px;
}
.editable-label {
    cursor: text;
    color: #409eff;
}
.inline-edit-container {
    max-width: 160px;
}
.material-chip-container {
    display: flex;
    flex-wrap: wrap;
    max-height: 200px;
    overflow-y: auto;
}
.material-chip {
    padding: 5px 10px;
    border-radius: 10px;
    line-height: 20px;
    text-align: center;
    margin: 5px 4px;
    border: 1px solid #ccc;
    cursor: pointer;
    transition: all 0.2s;
}
.material-chip:hover {
    border-color: #409eff;
    color: #409eff;
}
.material-chip.disabled {
    color: #bbb;
    border-color: #e0e0e0;
    background-color: #f5f5f5;
    cursor: not-allowed;
    pointer-events: none;
}
</style>
